export const COMPANY_SUPER_ADMIN_ROLE = 'Company Super Admin Role';
export const ROOT_COMPANY_ID = -1;
export const ISLATESTBUILD = true;
export const ISBETAVERSION = true;
